import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  ReactTags,
  Common,
  Spinner,
  Accordion,
  Multiselect,
  getBase64,
  swal
  // FileUploadWithPreview
} from '../../config/react'
import CheckboxTree from 'react-checkbox-tree'
import 'react-checkbox-tree/lib/react-checkbox-tree.css'
import UploadMedia from './UploadMedia'
import 'react-tag-autocomplete/example/src/styles.css'
import 'react-multiple-select-dropdown-lite/dist/index.css'
const renderErrors = (errors) => {
  return (
    <div>
      <p>
        <b>Below product images not uploaded!</b>
      </p>
      {errors.map((item, key) => (
        <p
          className="mb-1"
          key={Math.random()}
        >
          {item}
        </p>
      ))}
    </div>
  )
}
let ProductAttributeOptions = {}
const AddProducts = () => {
  const location = useLocation()
  const urlParams = useParams()
  const queryParams = new URLSearchParams(location.search)
  const FilterName = queryParams.get('name')
  const FilterAttributeSetId = queryParams.get('aid')
  const FilterPriceTo = queryParams.get('priceto')
  const FilterPriceFrom = queryParams.get('pricefrom')
  const FilterCategoryId = queryParams.get('cid')
  const FilterVendor = queryParams.get('vendor')
  const FilterSku = queryParams.get('sku')
  const fromPage = queryParams.get('page')
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const validator = useRef(new SimpleReactValidator())
  const user = useContext(UserContext)
  const submitButtonRef = useRef()
  const [IsShowImagesVideoModal, setIsShowImagesVideoModal] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [AttributeSet, setAttributeSetList] = useState([])
  const [Categories, setCategories] = useState([])
  const [AttributesBySet, setAttributesBySetList] = useState([])
  const [CustomAttributes, setCustomAttributes] = useState([])
  const [RelatedProducts, setRelatedProducts] = useState([])
  const [Products, setProducts] = useState([])
  const [ProductTags, setProductTags] = useState([])
  const [ProductMedia, setProductMedia] = useState({ images: [], video: [] })
  const [SelectedMedia, setSelectedMedia] = useState({ images: [], video: '' })
  const [ProductIndex, setProductIndex] = useState()
  const [ProductOptionKey, setProductOptionKey] = useState()
  // const [Vendorlist, setVendorlist] = useState([])
  const [SelectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [AttributeOptions, setAttributeOptions] = useState([])
  const [SelectedAttributeOptions, setSelectedAttributeOptions] = useState([])
  const [SelectedAttributes, setSelectedAttributes] = useState([])
  const [SelectedAttributeTags, setSelectedAttributeTags] = useState([])
  const [GroupByProperty, setGroupByProperty] = useState('')

  // const ProductAttributeOptions = useRef({})
  const [SizeList, setSizeList] = useState([])
  const [CurrentImageVariant, setCurrentImageVariant] = useState()
  const optionImagesRefArray = useRef([])
  const [activeKey, setActiveKey] = useState(0)
  const handleSelect = (key) => setActiveKey(key)
  const [IsShowSkuError, setIsShowSkuError] = useState(false)
  const [Shapes, setShapes] = useState([])
  const [ErrorMessages, setErrorMessages] = useState([])
  const [Inputs, setInputs] = useState({
    id: 0,
    description: '',
    attribute_set_id: '',
    name: '',
    sku: '',
    parent_sku: '',
    price: '',
    meta_title: '',
    meta_keywords: '',
    meta_description: '',
    weight: '',
    weight_unit: 'lb',
    is_sold: 0,
    is_gift_card: 0,
    is_readytoship: 0,
    qty: '',
    status: 1,
    can_be_set_with: [],
    product_details: [],
    side_diamonds_size: '',
    side_diamonds_pieces: '',
    side_diamonds_weight: '',
    side_diamonds_weight_unit: 'lb',
    images: [],
    videos: [],
    size_type: '',
    gender: '',
    vendor: 'Harmony Jewels',
    product_description: ''
  })

  // const [isExpired, setIsExpired] = useState(false)
  const [filterText, setFilterText] = useState('')
  const [expanded, setExpanded] = useState([])
  const [clicked, setClicked] = useState(false)
  const [batchInput, setBatchInput] = useState('')
  const [showTextarea, setShowTextarea] = useState(false)
  const [CountryList, setCountryList] = useState([])
  const [selectedCountryIds, setselectedCountryIds] = useState([])
  const [selectedCountryOptions, setselectedCountryOptions] = useState([])
  // standalone options
  const [SelectedStandAloneAttributeOptions, setSelectedStandAloneAttributeOptions] = useState([])
  const [SelectedStandAloneAttributeTags, setSelectedStandAloneAttributeTags] = useState([])
  console.log(SelectedStandAloneAttributeOptions, SelectedStandAloneAttributeTags)

  useEffect(() => {
    document.title = Title.AddProducts
    GetCountryList()
    GetProductAttributeSetList()
    GetShapeAttributeOptions()
    GetProductSizeCategoryList()
    // GetVendorlist()
    if (urlParams.id !== undefined) {
      document.title = Title.EditProducts
      GetProductDetail()
    } else {
      GetCategories()
      // initProductImagesPlugin()
    }
    // checkIfExpired()
  }, [urlParams.id])
  useEffect(() => {
    setCountryDropdownOptions()
  }, [selectedCountryIds])

  useEffect(() => {
    const batchInputString = Inputs.product_details
      .map((field) => `${field.label}:${field.value}`)
      .join('\n')
    setBatchInput(batchInputString)
    setForceUpdate(!isForceUpdate)
  }, [Inputs])
  // const GetVendorlist = () => {
  //   const param = {
  //     id: 65 // single attribute vendor id
  //   }
  //   HttpService.postApi(API.GetProductAttributeDetail, param).then((response) => {
  //     try {
  //       if (response.data.result[0]) {
  //         const data = response.data.result[0][0].attribute_options
  //         setVendorlist(data)
  //       }
  //     } catch (error) {
  //       console.error(error)
  //     }
  //   })
  // }

  const GetCountryList = () => {
    HttpService.getApi(API.GetCountryList).then((response) => {
      try {
        setCountryList(response.data.result)
      } catch (error) {
        console.error(error)
      }
    })
  }

  const GetProductSizeCategoryList = () => {
    HttpService.postApi(API.GetProductSizeCategoryList).then((response) => {
      if (response.data.status === true) {
        const data = response.data.result[0]
        setSizeList(data)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  // useEffect(() => {
  //   initProductImagesPlugin(Inputs.images)
  // }, [Inputs.images])
  const onCheck = (checkedValues) => {
    setSelectedCategoryIds(checkedValues)
  }

  const handleClick = () => {
    clicked ? setClicked('') : setClicked('text-left form-control custom-select show')
  }

  const onExpand = (value) => {
    setExpanded(value)
  }

  const onFilterChange = (e) => {
    setFilterText(e.target.value.toLowerCase())
  }
  const filterNodes = (nodes, searchText) => {
    const loweredSearchText = searchText.toLowerCase()
    return nodes
      .map((node) => {
        const isNodeMatching = node.label.toLowerCase().includes(loweredSearchText)
        let filteredChildren = null
        if (node.children) {
          filteredChildren = filterNodes(node.children, loweredSearchText)
        }
        if (isNodeMatching || (filteredChildren !== null && filteredChildren.length > 0)) {
          return {
            ...node,
            children: filteredChildren
          }
        }
        return null
      })
      .filter((node) => node !== null)
  }
  const filteredCategories = filterNodes(Categories, filterText)

  const GetShapeAttributeOptions = () => {
    HttpService.postApi(API.GetShapeAttributeOptions, null).then((response) => {
      setShapes(response.data.result)
    })
  }

  const setCountryDropdownOptions = () => {
    if (CountryList.length !== 0) {
      const SelectedCountryoptions = CountryList.filter((x) => selectedCountryIds.includes(x.id))
      setselectedCountryOptions(SelectedCountryoptions)
    }
  }
  const GetProductDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetAdminProductDetail, param).then(async (response) => {
      const data = response.data.result[0][0]
      if (response.data.result[4][0] !== undefined) {
        const Standaloneoptions = response.data.result[4][0].standalone_attributes
        console.log(Standaloneoptions)

        setSelectedStandAloneAttributeOptions(Standaloneoptions)
      }
      fetchMedia(data.sku)
      const CountryIds = data.countryIds
      setselectedCountryIds(CountryIds)
      GetAttributesBySetList(data.attribute_set_id)

      if (
        Common.GetJSON(response.data.result[1][0].related_products) !== null &&
        Common.GetJSON(response.data.result[1][0].related_products).length > 0
      )
        setProductTags(response.data.result[1][0].related_products)
      const productVariationOptions = []
      response.data.result[2].map((item, index) => {
        productVariationOptions.push(item)
        let attributes = item.attributes
        attributes = [...new Map(attributes.map((item) => [item.option_id, item])).values()]

        let productAttributeValues = item.product_attribute_values
        productAttributeValues = [
          ...new Map(productAttributeValues.map((item) => [item.option_id, item])).values()
        ]
        const optionIds = productAttributeValues.map((item) => item.option_id)
        const stringOptionIds = optionIds.join('_')

        productVariationOptions[index].id = stringOptionIds
        productVariationOptions[index].attributes = attributes
        productVariationOptions[index].product_attribute_values = productAttributeValues

        return true
      })
      const categoryIds =
        productVariationOptions.length > 0 ? productVariationOptions[0]?.category_ids : []
      // setLongDescription(data.description)
      if (categoryIds !== '' && categoryIds !== null && categoryIds.length > 0) {
        setSelectedCategoryIds(categoryIds.split(',').map(String))
        GetCategories(categoryIds.split(',').map(Number))
      } else {
        setSelectedCategoryIds(categoryIds)
        GetCategories(categoryIds)
      }
      const attributes = []
      const attributeOptions = []
      const images = []
      const videos = []
      if (productVariationOptions.length > 0) {
        productVariationOptions.map((item, index) => {
          if (index === 0) {
            item.attributes
              .filter((item) => item.is_standalone === 0)
              .map((attribute) => {
                if (
                  attributes.filter((a) => a.attribute_code === attribute.attribute_code).length < 1
                )
                  attributes.push({
                    attribute_code: attribute.attribute_code,
                    attribute_name: attribute.attribute_name
                  })
                return true
              })
          }

          item.attributes.map((attribute) => {
            attribute.sku = item.sku
            attribute.price = item.price
            attribute.base_image = item.base_image
            attribute.other_images = item.other_images
            attribute.video = item.video
            if (
              attributeOptions.length < 1 ||
              attributeOptions.filter(
                (x) =>
                  x.attribute_id === attribute.attribute_id && x.option_id === attribute.option_id
              ).length < 1
            )
              attributeOptions.push(attribute)
            return true
          })
          if (item.other_image !== null && item.other_image.length > 0) {
            item.other_image.map((image) => {
              const fileName = image.split('/').pop()
              if (images.filter((i) => i.image === image).length < 1)
                images.push({ name: fileName, image: image })
              return true
            })
          }
          if (
            item.video !== null &&
            item.video !== '' &&
            videos.filter((video) => video.video === item.video).length < 1
          ) {
            const fileName = item.video.split('/').pop()
            videos.push({ name: fileName, video: item.video })
          }
          return true
        })
      }

      const productImageLabel = 'images'
      const productVideoLabel = 'videos'
      data[productImageLabel] = images
      data[productVideoLabel] = videos
      setInputs(data)
      // initProductImagesPlugin(images.map((image) => image.image))
      if (response.data.result[3].length > 0) {
        const selectedOptions = response.data.result[3][0].selected_attributes.filter(
          (x) => x.is_standalone === 0
        )

        const selectedStandaloneOptions = response.data.result[3][0].selected_attributes.filter(
          (x) => x.is_standalone === 1
        )
        const standaloneOptionTags = []
        selectedStandaloneOptions.map((option) => {
          const attribute = Object.keys(option)
          const key = attribute[0] !== 'is_standalone' ? attribute[0] : attribute[1]
          standaloneOptionTags[key] = option[key]
          return true
        })
        setSelectedStandAloneAttributeTags(standaloneOptionTags)
        const optionTags = []
        selectedOptions.map((item) => {
          const attribute = Object.keys(item)
          optionTags[attribute[0]] = item[attribute[0]]
          return true
        })
        setSelectedAttributeTags(optionTags)
      }
      let attributeData = {}
      attributeOptions.map((item, index) => {
        const tempOptions = attributeOptions
          .filter((attr) => attr.attribute_code === item.attribute_code)
          .map((i) => i.option_id)
        attributeData[item.attribute_code] = tempOptions
        return true
      })
      // const combination = Common.generateCombination(attributeData)
      const attributeKeys = Object.keys(attributeData)
      attributeKeys.sort()
      let groupByProperty = attributeKeys[0]
      if (
        data.variation_group_by_property !== undefined &&
        data.variation_group_by_property !== null &&
        data.variation_group_by_property !== '' &&
        attributeKeys.indexOf(data.variation_group_by_property) > -1
      ) {
        groupByProperty = data.variation_group_by_property
      }
      attributeData = Common.groupByProperty(productVariationOptions, groupByProperty)

      setAttributeOptions(attributeData)
      setSelectedAttributeOptions(attributeOptions)
      //  setSelectedStandAloneAttributeOptions(attributeOptions)
      setSelectedAttributes(attributes)

      if (attributeOptions.length > 0) {
        if (attributeOptions.filter((item) => item.attribute_code === groupByProperty).length > 0) {
          prepareGroupBy(groupByProperty)
          setGroupByProperty(groupByProperty)
        } else {
          prepareGroupBy(attributeOptions[0].attribute_code)
          setGroupByProperty(attributeOptions[0].attribute_code)
        }
      }
      // ProductAttributeOptions = JSON.parse(JSON.stringify(attributeData))
      // setForceUpdate(!isForceUpdate)
      setLoading(false)
    })
  }
  const onChangeProduct = (value) => {
    if (value === undefined || value.trim().length < 3) return setProducts()
    new Promise((resolve) => {
      const param = {
        term: value
      }
      HttpService.postApi(API.SearchProducts, param).then((response) => {
        let products = []
        if (response.data.result.length > 0) {
          products = response.data.result.map((item) => ({
            value: item.id,
            label: item.name + ' - ' + item.sku
          }))
        } else products = []
        setProducts(products)
        setForceUpdate(!isForceUpdate)
        resolve(products)
      })
    })
  }
  const onDeleteProduct = (i) => {
    const newTags = ProductTags.slice(0)
    newTags.splice(i, 1)
    setProductTags(newTags)
    setRelatedProducts(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onSelectProduct = (tag) => {
    const newTags = [...ProductTags, tag]
    setProductTags(newTags)
    setRelatedProducts(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value

    if (
      field === 'status' ||
      field === 'is_sold' ||
      field === 'view_360' ||
      field === 'is_gift_card' ||
      field === 'is_readytoship'
    ) {
      setInputs({ ...Inputs, [field]: e.target.checked })
    } else if (field === 'attribute_set_id') {
      setInputs({ ...Inputs, [field]: fieldval })
      GetAttributesBySetList(fieldval)
    } else if (field === 'vendor') {
      setInputs({ ...Inputs, [field]: fieldval })
    } else {
      setInputs({ ...Inputs, [field]: fieldval })
    }
    setForceUpdate(!isForceUpdate)
  }
  const validateProductSku = (e) => {
    if (e.target.value.trim() !== '') {
      const param = {
        sku: e.target.value,
        id: urlParams.id !== undefined ? urlParams.id : 0
      }
      HttpService.postApi(API.ValidateProductSku, param).then((response) => {
        if (response.data.result[0].total_sku > 0) {
          setIsShowSkuError(true)
        } else {
          setIsShowSkuError(false)
          fetchMedia(e.target.value)
        }
      })
    }
  }
  const fetchMedia = (productSku) => {
    const param = {
      sku: productSku
    }
    HttpService.postApi(API.FetchProductMedia, param).then((response) => {
      setProductMedia(response.data.result)
    })
  }
  const handleOptionChange = (e, attributeCode, attributeId, attributeName) => {
    let attributeOptions = SelectedAttributeOptions.filter(
      (item) => item.attribute_code !== attributeCode
    )
    e.map((item) => {
      attributeOptions.push({
        attribute_code: attributeCode,
        attribute_name: attributeName,
        attribute_id: attributeId,
        option_id: item.id,
        option_value: item.name
      })
      return true
    })
    const updatedStandAloneTags = { ...SelectedStandAloneAttributeTags }
    delete updatedStandAloneTags[attributeCode]

    const updatedStandAloneOptions = SelectedStandAloneAttributeOptions.filter(
      (item) => item.attribute_code !== attributeCode
    )
    setSelectedStandAloneAttributeOptions(updatedStandAloneOptions)
    setSelectedStandAloneAttributeTags(updatedStandAloneTags)
    setSelectedAttributeOptions(attributeOptions)
    setSelectedAttributeTags({ ...SelectedAttributeTags, [attributeCode]: e })
    // setSelectedAttributeOptions({ ...SelectedAttributeOptions, [attributeCode]: e })
    attributeOptions = prepareVariants(attributeOptions)
    let attributeData = []
    if (Object.values(attributeOptions).length > 1) {
      Object.values(attributeOptions).map((productOptions) => {
        productOptions.map((item) => {
          attributeData.push(item)
          return true
        })
        return true
      })
    } else {
      attributeData = Object.values(attributeOptions)[0]
    }
    let groupBy = GroupByProperty
    // if (groupBy === '') {
    if (attributeData !== undefined) {
      if (groupBy === '') {
        groupBy = attributeData[0].attributes[0].attribute_code
        setGroupByProperty(groupBy)
      }
      // }
      if (!Common.isGroupByPropertyExist(attributeData, groupBy)) {
        groupBy = attributeData[0].attributes[0].attribute_code
        setGroupByProperty(groupBy)
      }
      attributeData = Common.groupByProperty(attributeData, groupBy)

      setAttributeOptions(attributeData)
      ProductAttributeOptions = attributeData
      // ProductAttributeOptions = JSON.parse(JSON.stringify(attributeData))
      // prepareGroupBy(GroupByProperty)
    } else {
      setAttributeOptions({})
      ProductAttributeOptions = {}
      // ProductAttributeOptions = JSON.parse(JSON.stringify({}))
    }
    // setForceUpdate(!isForceUpdate)
  }
  const prepareVariants = (selectedAttributeOptions) => {
    let attributeData = {}
    selectedAttributeOptions.map((item, index) => {
      const tempOptions = selectedAttributeOptions
        .filter((attr) => attr.attribute_code === item.attribute_code)
        .map((i) => i.option_id)
      attributeData[item.attribute_code] = tempOptions
      return true
    })
    const combination = Common.generateCombination(attributeData)
    attributeData = []
    const attributes = []
    combination.map((item, index) => {
      const objKeys = Object.keys(item)
      const attributeOptions = []
      const productAttributeOptions = []
      objKeys.map((key) => {
        const optionName =
          selectedAttributeOptions.filter((x) => x.attribute_code === key).length > 0
            ? selectedAttributeOptions.filter((x) => x.attribute_code === key)[0].attribute_name
            : ''
        const optionValue =
          selectedAttributeOptions.filter(
            (x) => x.attribute_code === key && x.option_id === item[key]
          ).length > 0
            ? selectedAttributeOptions.filter(
                (x) => x.attribute_code === key && x.option_id === item[key]
              )[0].option_value
            : ''
        const optionId =
          selectedAttributeOptions.filter(
            (x) => x.attribute_code === key && x.option_id === item[key]
          ).length > 0
            ? selectedAttributeOptions.filter(
                (x) => x.attribute_code === key && x.option_id === item[key]
              )[0].option_id
            : ''
        const attributeId =
          selectedAttributeOptions.filter(
            (x) => x.attribute_code === key && x.option_id === item[key]
          ).length > 0
            ? selectedAttributeOptions.filter(
                (x) => x.attribute_code === key && x.option_id === item[key]
              )[0].attribute_id
            : ''
        const attributeName =
          selectedAttributeOptions.filter(
            (x) => x.attribute_code === key && x.option_id === item[key]
          ).length > 0
            ? selectedAttributeOptions.filter(
                (x) => x.attribute_code === key && x.option_id === item[key]
              )[0].attribute_name
            : ''
        attributeOptions.push({
          option_name: optionName,
          option_value: optionValue,
          option_id: optionId,
          attribute_id: attributeId,
          attribute_code: key,
          attribute_name: attributeName,
          option_ids: selectedAttributeOptions
            .filter((x) => x.attribute_code === key)
            .map((item) => item.option_id)
        })
        productAttributeOptions.push({ attribute_id: attributeId, option_id: optionId })
        if (attributes.filter((item) => item.attribute_code === key).length < 1)
          attributes.push({ attribute_code: key, attribute_name: optionName })
        return true
      })
      const optionIds = productAttributeOptions.map((item) => item.option_id).map(Number)
      const stringOptionIds = optionIds.join('_')
      const productAttributeOptionList = []

      if (Object.values(ProductAttributeOptions).length > 0) {
        Object.values(ProductAttributeOptions).map((items) => {
          items.map((item) => {
            productAttributeOptionList.push(item)
            return true
          })
          return true
        })
      }
      const defaultVariantOptionId = item[GroupByProperty]
      const defaultPrice =
        Object.keys(ProductAttributeOptions)?.length > 0 &&
        ProductAttributeOptions[defaultVariantOptionId]?.length > 0
          ? ProductAttributeOptions[defaultVariantOptionId][0].price
          : 0
      const defaultSku = Common.generateRandomString(4)
      attributeData.push({
        id: stringOptionIds,
        attributes: attributeOptions,
        product_attribute_values: productAttributeOptions,
        // sku:
        //   productAttributeOptionList.filter((item) =>
        //     item.id
        //       .split('_')
        //       .map(Number)
        //       .every((element) => optionIds.includes(element))
        //   ).length > 0
        //     ? productAttributeOptionList.filter((item) =>
        //         item.id
        //           .split('_')
        //           .map(Number)
        //           .every((element) => optionIds.includes(element))
        //       )[0].sku
        //     : Inputs.sku !== ''
        //       ? Inputs.sku + '-' + defaultSku
        //       : '',
        sku: Inputs.sku + '-' + defaultSku,
        model_number:
          productAttributeOptionList.filter((item) =>
            item.id
              .split('_')
              .map(Number)
              .every((element) => optionIds.includes(element))
          ).length > 0
            ? productAttributeOptionList.filter((item) =>
                item.id
                  .split('_')
                  .map(Number)
                  .every((element) => optionIds.includes(element))
              )[0].model_number
            : '',
        price:
          productAttributeOptionList.filter((item) =>
            item.id
              .split('_')
              .map(Number)
              .every((element) => optionIds.includes(element))
          ).length > 0
            ? productAttributeOptionList.filter((item) =>
                item.id
                  .split('_')
                  .map(Number)
                  .every((element) => optionIds.includes(element))
              )[0].price
            : defaultPrice,
        base_image:
          productAttributeOptionList.filter((item) =>
            item.id
              .split('_')
              .map(Number)
              .every((element) => optionIds.includes(element))
          ).length > 0
            ? productAttributeOptionList.filter((item) =>
                item.id
                  .split('_')
                  .map(Number)
                  .every((element) => optionIds.includes(element))
              )[0].base_image
            : '',
        other_images:
          productAttributeOptionList.filter((item) =>
            item.id
              .split('_')
              .map(Number)
              .every((element) => optionIds.includes(element))
          ).length > 0
            ? productAttributeOptionList.filter((item) =>
                item.id
                  .split('_')
                  .map(Number)
                  .every((element) => optionIds.includes(element))
              )[0].other_images
            : []
      })
      return true
    })
    setSelectedAttributes(attributes)
    const groupByProperty = Object.keys(combination[0])[0]
    attributeData = Common.groupByProperty(attributeData, groupByProperty)
    return attributeData
  }
  const handleChangeGroupBy = (e) => {
    setGroupByProperty(e.target.value)
    prepareGroupBy(e.target.value)
    setForceUpdate(!isForceUpdate)
  }
  const prepareGroupBy = (groupByProperty) => {
    let attributeData = []
    if (Object.values(ProductAttributeOptions).length > 1) {
      Object.values(ProductAttributeOptions).map((productOptions) => {
        productOptions.map((item) => {
          attributeData.push(item)
          return true
        })
        return true
      })
    } else {
      attributeData = Object.values(ProductAttributeOptions)[0]
    }
    attributeData = Common.groupByProperty(attributeData, groupByProperty)
    setAttributeOptions(attributeData)
    ProductAttributeOptions = attributeData
  }
  const openMediaPopup = (e, optionKey, index) => {
    setProductIndex(index)
    index = index === '' ? 0 : index
    const images =
      ProductAttributeOptions[optionKey][index].other_images !== undefined
        ? ProductAttributeOptions[optionKey][index].other_images
        : []
    const baseImage = ProductAttributeOptions[optionKey][index].base_image ?? ''
    if (baseImage !== '') images.push(baseImage)
    setSelectedMedia({
      base_image: baseImage,
      images: images,
      video: ProductAttributeOptions[optionKey][index].video ?? ''
    })
    setIsShowImagesVideoModal(true)
    setCurrentImageVariant(ProductAttributeOptions[optionKey][index].attributes)
    setProductOptionKey(optionKey)
  }
  const closeMediaPopup = (e) => {
    setIsShowImagesVideoModal(false)
  }
  const onSubmitMedia = (media, imageOptionId = '') => {
    const images = media.images
    const baseImage =
      media.base_image !== undefined && media.base_image !== '' ? media.base_image : images[0]
    const attributeOptions = AttributeOptions
    if (ProductIndex !== '') {
      if (imageOptionId !== '') {
        attributeOptions[ProductOptionKey].map((item, index) => {
          if (
            imageOptionId !== '' &&
            item.attributes.filter((x) => x.option_id === parseInt(imageOptionId)).length > 0
          ) {
            attributeOptions[ProductOptionKey][index].base_image = baseImage
            attributeOptions[ProductOptionKey][index].other_images = images.filter(
              (image) => image !== baseImage
            )
            attributeOptions[ProductOptionKey][index].video = media.video
            return true
          }
          return true
        })
      } else {
        attributeOptions[ProductOptionKey][ProductIndex].base_image = baseImage
        attributeOptions[ProductOptionKey][ProductIndex].other_images = images.filter(
          (image) => image !== images.base_image
        )
        attributeOptions[ProductOptionKey][ProductIndex].video = media.video
      }
    } else {
      attributeOptions[ProductOptionKey].map((item, index) => {
        attributeOptions[ProductOptionKey][index].base_image = baseImage
        attributeOptions[ProductOptionKey][index].other_images = images.filter(
          (image) => image !== baseImage
        )
        attributeOptions[ProductOptionKey][index].video = media.video
        return true
      })
    }
    setAttributeOptions(attributeOptions)
    ProductAttributeOptions = attributeOptions
    setIsShowImagesVideoModal(false)
    setForceUpdate(!isForceUpdate)
  }
  // const SyncMedia = () => {
  //   if (isExpired === true) {
  //     window.open(`/dropboximagesync?sku=${Inputs.sku}`, '_blank')
  //   } else {
  //     const param = {
  //       parent_sku: Inputs.sku
  //     }
  //     HttpService.postApi(API.SyncProductMedia, param).then((response) => {
  //       return true
  //     })
  //   }
  // }
  // const checkIfExpired = () => {
  //   const expirationTimestamp = localStorage.getItem('tokenExpiration')
  //   const currentTime = Date.now()

  //   if (expirationTimestamp && currentTime > parseInt(expirationTimestamp)) {
  //     setIsExpired(true)
  //   } else {
  //     setIsExpired(false)
  //   }
  // }
  const GetAttributesBySetList = (id) => {
    if (id !== '') {
      const param = {
        set_id: id
      }
      HttpService.postApi(API.GetAttributesBySetList, param).then((response) => {
        const data = response.data.result[0]
        const attributes = []
        data.map((item) => {
          if (
            item.input_type === 'dropdown' ||
            item.input_type === 'radio' ||
            item.input_type === 'range_slider' ||
            item.input_type === 'text_swatch'
          ) {
            attributes.push({
              attribute_id: item.attribute_id,
              attribute_code: item.attribute_code,
              attribute_name: item.attribute_name,
              options: item.attribute_option
            })
          }
          return true
        })
        setAttributesBySetList(attributes)
        // setGroupByProperty(attributes[0].attribute_code)
        setCustomAttributes(data.filter((item) => item.input_type === 'text'))
        setForceUpdate(!isForceUpdate)
        return attributes
      })
    }
  }
  const handleCustomAttributeValue = (e, attributeIndex) => {
    e.preventDefault()
    const customAttributes = CustomAttributes
    customAttributes[attributeIndex].attribute_value = e.target.value
    setCustomAttributes(customAttributes)
  }
  const GetProductAttributeSetList = () => {
    HttpService.getApi(API.GetProductAttributeSetList).then((response) => {
      setAttributeSetList(response.data.result[0].filter((x) => x.status === 1))
      setForceUpdate(!isForceUpdate)
    })
  }
  // const onChangeCategory = (currentNode, selectedNodes) => {
  //   const array = []
  //   if (selectedNodes.length > 0) {
  //     for (let i = 0; i < selectedNodes.length; i++) {
  //       array.push(selectedNodes[i].value)
  //     }
  //   }
  //   setSelectedCategoryIds(array)
  //   Categories.map((item, index) => {
  //     if (array.indexOf(item.value) >= 0) {
  //       Categories[index].checked = true
  //     } else {
  //       Categories[index].checked = false
  //     }
  //     item.children.map((subitem, subindex) => {
  //       if (array.indexOf(subitem.value) >= 0) {
  //         Categories[index].children[subindex].checked = true
  //       } else {
  //         Categories[index].children[subindex].checked = false
  //       }
  //       subitem.children.map((subitem1, subindex1) => {
  //         if (array.indexOf(subitem1.value) >= 0) {
  //           Categories[index].children[subindex].children[subindex1].checked = true
  //         } else {
  //           Categories[index].children[subindex].children[subindex1].checked = false
  //         }
  //         return true
  //       })
  //       return true
  //     })
  //     return true
  //   })
  // }

  // const GetCategories = (selectedCategory = []) => {
  //   HttpService.postApi(API.GetCategory, null).then((response) => {
  //     if (response.data.result) {
  //       // filter parent category
  //       const parentCategories = response.data.result[0].filter(
  //         (x) => x.parent_id === 1 && x.is_diamond_category === 0
  //       )
  //       const categories = []

  //       parentCategories.map((item) => {
  //         // filter sub categories by parent
  //         const filteredSubcategories = response.data.result[0].filter(
  //           (x) => x.parent_id === item.id && x.status
  //         )
  //         const subcategories = []

  //         filteredSubcategories.map((subitem) => {
  //           // filter sub child categories by parent
  //           const filteredSubChildCategories = response.data.result[0].filter(
  //             (x) => x.parent_id === subitem.id && x.status
  //           )
  //           const subchildcategories = []

  //           filteredSubChildCategories.map((subchilditem) => {
  //             const filteredChildCategories = response.data.result[0].filter(
  //               (x) => x.parent_id === subchilditem.id && x.status
  //             )
  //             const childcategories = []

  //             filteredChildCategories.map((childitem) => {
  //               const filteredChildrenCategories = response.data.result[0].filter(
  //                 (x) => x.parent_id === childitem.id && x.status
  //               )
  //               const childrencategories = []
  //               filteredChildrenCategories.map((childrenitem) => {
  //                 let checked = false
  //                 if (
  //                   (urlParams.id !== undefined && Inputs.category_id === childrenitem.id) ||
  //                   selectedCategory === childrenitem.id
  //                 )
  //                   checked = true
  //                 childrencategories.push({
  //                   label: childrenitem.name,
  //                   value: childrenitem.id,
  //                   checked
  //                   // children: subcategories
  //                 })
  //                 return true
  //               })

  //               let checked = false
  //               if (
  //                 (urlParams.id !== undefined && Inputs.category_id === childitem.id) ||
  //                 selectedCategory === childitem.id
  //               )
  //                 checked = true
  //               childcategories.push({
  //                 label: childitem.name,
  //                 value: childitem.id,
  //                 checked,
  //                 children: childrencategories
  //               })
  //               return true
  //             })

  //             let checked = false
  //             if (
  //               (urlParams.id !== undefined && Inputs.category_id === subchilditem.id) ||
  //               selectedCategory === subchilditem.id
  //             )
  //               checked = true
  //             subchildcategories.push({
  //               label: subchilditem.name,
  //               value: subchilditem.id,
  //               checked,
  //               children: childcategories
  //             })
  //             return true
  //           })

  //           let checked = false
  //           if (
  //             (urlParams.id !== undefined && Inputs.category_id === subitem.id) ||
  //             selectedCategory === subitem.id
  //           )
  //             checked = true
  //           subcategories.push({
  //             label: subitem.name,
  //             value: subitem.id,
  //             checked,
  //             children: subchildcategories
  //           })
  //           return true
  //         })
  //         let checked = false
  //         if (
  //           (urlParams.id !== undefined && Inputs.category_id === item.id) ||
  //           selectedCategory === item.id
  //         )
  //           checked = true
  //         categories.push({
  //           label: item.name,
  //           value: item.id,
  //           children: subcategories,
  //           checked
  //         })
  //         return true
  //       })

  //       setCategories(categories)
  //     }
  //   })
  // }
  const GetCategories = (selectedCategory = []) => {
    HttpService.postApi(API.GetCategory, null).then((response) => {
      if (response.data.result) {
        const lastNodeIds = []

        const buildTree = (parentId) => {
          const nodes = response.data.result[0]
            .filter((x) => x.parent_id === parentId && x.status)
            .map((item) => {
              const children = buildTree(item.id)

              // If the node has no children, it's a leaf node
              if (children.length === 0) {
                lastNodeIds.push(item.id) // Add leaf node's ID to lastNodeIds
              }

              const allChildrenSelected =
                children.length > 0 && children.every((child) => child.checked) // All children are selected
              const checked = allChildrenSelected || selectedCategory.includes(item.id) // Check if all children or the current category is selected

              return {
                label: item.name,
                value: item.id,
                checked,
                children
              }
            })

          return nodes
        }

        const categories = buildTree(1)
        setCategories(categories)

        const updatedSelectedCategoryIds = selectedCategory.filter((id) => lastNodeIds.includes(id))

        setSelectedCategoryIds(updatedSelectedCategoryIds)

        // console.log('Last node IDs: ', lastNodeIds)
        // console.log('Updated SelectedCategoryIds: ', updatedSelectedCategoryIds)
      }
    })
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      const errorMessages = []
      Object.keys(validator.current.errorMessages).map((key) => {
        if (validator.current.errorMessages[key] !== null)
          errorMessages[key] = validator.current.errorMessages[key]
        return true
      })
      setErrorMessages(errorMessages)
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // for smooth scrolling
      })
      // validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    } else {
      setErrorMessages({})
    }
    const param = {
      id: Inputs.id,
      attribute_set_id: Inputs.attribute_set_id,
      is_configured: ProductAttributeOptions.length > 0 ? 1 : 0,
      parent_product_id: ProductAttributeOptions.length > 0 ? 0 : Inputs.parent_product_id,
      description: Inputs.description,
      is_sold: Inputs.is_sold === true || Inputs.is_sold === '1' ? 1 : 0,
      is_gift_card: Inputs.is_gift_card === true || Inputs.is_gift_card === '1' ? 1 : 0,
      is_readytoship: Inputs.is_readytoship === true || Inputs.is_readytoship === '1' ? 1 : 0,
      meta_description: Inputs.meta_description,
      meta_keywords: Inputs.meta_keywords,
      meta_title: Inputs.meta_title,
      name: Inputs.name,
      parent_sku: Inputs.parent_sku,
      sku: Inputs.sku,
      status: Inputs.status === true || parseInt(Inputs.status) === 1 ? 1 : 0,
      weight:
        Inputs.weight !== null && Inputs.weight !== '' ? parseFloat(Inputs.weight).toFixed(2) : 0,
      weight_unit: Inputs.weight_unit,
      Userid: user.id,
      attribute_options: ProductAttributeOptions,
      category_id: SelectedCategoryIds,
      related_products: RelatedProducts,
      can_be_set_with: Inputs.can_be_set_with,
      can_be_set_with_shape:
        Inputs.can_be_set_with.length > 0 ? Inputs.can_be_set_with.map((item) => item.shape) : [],
      side_diamonds_size: Inputs.side_diamonds_size,
      side_diamonds_pieces: Inputs.side_diamonds_pieces,
      side_diamonds_weight: Inputs.side_diamonds_weight,
      side_diamonds_weight_unit: Inputs.side_diamonds_weight_unit,
      images: Inputs.images,
      videos: Inputs.videos,
      variation_group_by_property: GroupByProperty,
      product_details: Inputs.product_details.length > 0 ? Inputs.product_details : [],
      size_type: Inputs.size_type,
      gender: Inputs.gender === '' ? 0 : Inputs.gender,
      vendor: Inputs.vendor,
      countryids: JSON.stringify(selectedCountryIds).replaceAll('[', '').replaceAll(']', ''),
      standalone_attributes:
        SelectedStandAloneAttributeOptions.length !== 0 ? SelectedStandAloneAttributeOptions : [],
      product_description: Inputs.product_description
    }
    setLoading(true)
    if (submitButtonRef.current) submitButtonRef.current.setAttribute('disabled', 'disabled')
    HttpService.postApi(API.SetProducts, param).then((response) => {
      setLoading(false)
      submitButtonRef.current.removeAttribute('disabled')
      if (Array.isArray(response.data.result)) {
        swal({
          title: Messages.oops,
          content: renderErrors(response.data.result),
          icon: 'error',
          buttons: {
            cancel: true,
            confirm: false
          }
        })
        setForceUpdate(!isForceUpdate)
      } else if (response.data.result.message) {
        toast.error(response.data.result.message)
      } else {
        if (urlParams.id === undefined) {
          toast.success(Messages.RecordAdded)
        } else {
          toast.success(Messages.RecordUpdated)
        }
        setForceUpdate(!isForceUpdate)

        history.push('/products', {
          state: {
            page: parseInt(fromPage) === 0 ? 1 : parseInt(fromPage),
            name: FilterName,
            sku: FilterSku,
            attribute_set_id: FilterAttributeSetId,
            priceTo: FilterPriceTo,
            priceFrom: FilterPriceFrom,
            categoryIds: FilterCategoryId,
            vendor: FilterVendor
          }
        })
      }
    })
  }
  // const onCloseVariationModal = () => {
  //   setIsShowVariationModal(false)
  //   setForceUpdate(!isForceUpdate)
  // }
  useEffect(() => {
    ProductAttributeOptions = AttributeOptions
  }, [AttributeOptions])

  const handleMainVariationChange = (optionKey) => async (e) => {
    e.preventDefault()
    const attributeOptions = AttributeOptions
    if (e.target.name === 'sku') {
      attributeOptions[optionKey].map((item) => (item.sku = e.target.value))
    } else if (e.target.name === 'price') {
      attributeOptions[optionKey].map((item) => (item.price = e.target.value))
    } else if (e.target.name === 'image') {
      optionImagesRefArray.current[optionKey].src = URL.createObjectURL(e.target.files[0])
      const base64Image = await new Promise((resolve, reject) => {
        getBase64(e.target.files[0], (result) => {
          resolve(result)
        })
      })
      attributeOptions[optionKey].map((item) => (item.image = base64Image))
    }
    setAttributeOptions(attributeOptions)
    ProductAttributeOptions = attributeOptions
    setForceUpdate(!isForceUpdate)
  }
  const handleVariationChange = (optionKey, index) => async (e) => {
    e.preventDefault()
    let fieldValue = e.target.value
    if (e.target.name === 'image') {
      fieldValue = await new Promise((resolve, reject) => {
        getBase64(e.target.files[0], (result) => {
          resolve(result)
        })
      })
    }
    const attributeOptions = AttributeOptions
    attributeOptions[optionKey][index][e.target.name] = fieldValue
    setAttributeOptions(attributeOptions)
    ProductAttributeOptions = attributeOptions
    // setForceUpdate(!isForceUpdate)
  }
  const handleDelete = (index) => (e) => {
    e.preventDefault()
    let canBeSetWithOptions = Inputs.can_be_set_with
    canBeSetWithOptions = canBeSetWithOptions.filter(function (item, currentIndex) {
      return currentIndex !== index
    })
    const canBeSetWithLabel = 'can_be_set_with'
    setInputs({
      ...Inputs,
      [canBeSetWithLabel]: canBeSetWithOptions
    })
    setForceUpdate(!isForceUpdate)
  }
  const handleAddCanBeSet = (e) => {
    e.preventDefault()
    const canBeSetWithOptions = Inputs.can_be_set_with
    canBeSetWithOptions.push({ shape: '', carat_from: '', carat_to: '' })
    const canBeSetWithLabel = 'can_be_set_with'
    setInputs({
      ...Inputs,
      [canBeSetWithLabel]: canBeSetWithOptions
    })
    setForceUpdate(!isForceUpdate)
  }
  const handleOnCanBeSetChange = (index) => (e) => {
    e.preventDefault()
    const canBeSetWithOptions = Inputs.can_be_set_with
    canBeSetWithOptions[index] = { ...canBeSetWithOptions[index], [e.target.name]: e.target.value }
    const canBeSetWithLabel = 'can_be_set_with'
    setInputs({
      ...Inputs,
      [canBeSetWithLabel]: canBeSetWithOptions
    })
    setForceUpdate(!isForceUpdate)
  }
  const handleAccordionClick = (key) => {
    setActiveKey(key === activeKey ? null : key)
  }
  // const RemoveVideo = (e) => {
  //   // e.preventDefault()
  //   // initVideoPlugin()
  //   const videoLabel = 'videos'
  //   setInputs({
  //     ...Inputs,
  //     [videoLabel]: []
  //   })
  // }
  window.addEventListener('fileUploadWithPreview:imagesAdded', async function (e) {
    e.preventDefault()
    const detail = e.detail
    setLoading(true)
    if (detail.uploadId === 'productImages') {
      const images = []
      const promises = detail.cachedFileArray.map(async (file) => {
        const imageType = file.type
        if (imageType === 'image/jpeg' || imageType === 'image/jpg' || imageType === 'image/png') {
          const image = await new Promise((resolve, reject) => {
            getBase64(file, (result) => {
              resolve(result)
            })
          })
          const fileName = file.name.includes(':') ? file.name.split(':')[0] : file.name
          images.push({ name: fileName, image: image })
          return image
        }
      })
      await Promise.all(promises)
      setLoading(false)
      const productImageLabel = 'images'
      setInputs({
        ...Inputs,
        [productImageLabel]: images
      })
    }
  })
  window.addEventListener('fileUploadWithPreview:imageDeleted', async function (e) {
    e.preventDefault()
    const detail = e.detail
    setLoading(true)
    if (detail.uploadId === 'productImages') {
      const images = []
      const promises = detail.cachedFileArray.map(async (file) => {
        const imageType = file.type
        if (imageType === 'image/jpeg' || imageType === 'image/jpg' || imageType === 'image/png') {
          const image = await new Promise((resolve, reject) => {
            getBase64(file, (result) => {
              resolve(result)
            })
          })
          const fileName = file.name.includes(':') ? file.name.split(':')[0] : file.name
          images.push({ name: fileName, image: image })
          return image
        }
      })
      await Promise.all(promises)
      setLoading(false)
      const productImagesLabel = 'images'
      setInputs({
        ...Inputs,
        [productImagesLabel]: images
      })
      setForceUpdate(!isForceUpdate)
    }
  })

  // new
  const handleStandAloneOptionChange = (e, attributeCode, attributeId, attributeName) => {
    const StandAloneAttributeOptions = SelectedStandAloneAttributeOptions.filter(
      (item) => item.attribute_code !== attributeCode
    )
    e.map((item) => {
      StandAloneAttributeOptions.push({
        attribute_code: attributeCode,
        attribute_name: attributeName,
        attribute_id: attributeId,
        option_id: item.id,
        option_value: item.name
      })
      return true
    })
    setSelectedStandAloneAttributeOptions(StandAloneAttributeOptions)
    setSelectedStandAloneAttributeTags({
      ...SelectedStandAloneAttributeTags,
      [attributeCode]: e
    })
  }
  const onSelectAllStandaloneOptions = (attributeCode) => {
    const attribute = AttributesBySet.filter((item) => item.attribute_code === attributeCode)

    const StandAloneAttributeOptions = SelectedStandAloneAttributeOptions.filter(
      (item) => item.attribute_code !== attributeCode
    )
    attribute[0].options.map((item) => {
      StandAloneAttributeOptions.push({
        attribute_code: attributeCode,
        attribute_name: attribute[0].attribute_name,
        attribute_id: attribute[0].attribute_id,
        option_id: item.id,
        option_value: item.name
      })
      return true
    })

    setSelectedStandAloneAttributeOptions(StandAloneAttributeOptions)
    setSelectedStandAloneAttributeTags({
      ...SelectedStandAloneAttributeTags,
      [attributeCode]: attribute[0].options
    })
  }
  const onSelectAll = (attributeCode) => {
    const attribute = AttributesBySet.filter((item) => item.attribute_code === attributeCode)
    let attributeOptions = SelectedAttributeOptions.filter(
      (item) => item.attribute_code !== attributeCode
    )
    attribute[0].options.map((item) => {
      attributeOptions.push({
        attribute_code: attributeCode,
        attribute_name: attribute[0].attribute_name,
        attribute_id: attribute[0].attribute_id,
        option_id: item.id,
        option_value: item.name
      })
      return true
    })
    setSelectedAttributeOptions(attributeOptions)
    setSelectedAttributeTags({
      ...SelectedAttributeTags,
      [attributeCode]: attribute[0].options
    })
    attributeOptions = prepareVariants(attributeOptions)
    let attributeData = []
    if (Object.values(attributeOptions).length > 1) {
      Object.values(attributeOptions).map((productOptions) => {
        productOptions.map((item) => {
          attributeData.push(item)
          return true
        })
        return true
      })
    } else {
      attributeData = Object.values(attributeOptions)[0]
    }
    const groupByProperty = attributeData[0].attributes[0].attribute_code
    setGroupByProperty(groupByProperty)
    attributeData = Common.groupByProperty(attributeData, groupByProperty)
    if (Object.values(attributeData).length > 0) {
      setAttributeOptions(attributeData)
      ProductAttributeOptions = attributeData
      setForceUpdate(!isForceUpdate)
      // prepareGroupBy(groupByProperty)
    }
  }

  // product details
  const handleAddProductDetails = (e) => {
    e.preventDefault()
    const ProductDetailsOptions = Inputs.product_details
    ProductDetailsOptions.push({ label: '', value: '' })
    const ProductDetailsLabel = 'product_details'
    setInputs({
      ...Inputs,
      [ProductDetailsLabel]: ProductDetailsOptions
    })
    setForceUpdate(!isForceUpdate)
  }

  const handleDeleteOption = (index) => (e) => {
    e.preventDefault()
    let ProductDetailsOptions = Inputs.product_details
    ProductDetailsOptions = ProductDetailsOptions.filter(function (item, currentIndex) {
      return currentIndex !== index
    })
    const ProductDetailsLabel = 'product_details'
    setInputs({
      ...Inputs,
      [ProductDetailsLabel]: ProductDetailsOptions
    })
    setForceUpdate(!isForceUpdate)
  }

  const handleOnProductDetailsChange = (index) => (e) => {
    e.preventDefault()
    const ProductDetailsOptions = Inputs.product_details
    ProductDetailsOptions[index] = {
      ...ProductDetailsOptions[index],
      [e.target.name]: e.target.value
    }
    const ProductDetailsLabel = 'product_details'
    setInputs({
      ...Inputs,
      [ProductDetailsLabel]: ProductDetailsOptions
    })
    setForceUpdate(!isForceUpdate)
  }

  const handleDeleteConfigureoption = (e, key, id, index) => {
    e.preventDefault()
    const configurationoptions = ProductAttributeOptions
    configurationoptions[key][index].isdisable =
      configurationoptions[key][index].isdisable === 1 ? 0 : 1
    ProductAttributeOptions = configurationoptions
    setForceUpdate(!isForceUpdate)
  }

  // const handleVideoChange = async (e) => {
  //   const videos = []
  //   const files = e.target.files
  //   for (let i = 0; i < files.length; i++) {
  //     const video = await new Promise((resolve, reject) => {
  //       getBase64(files[i], (result) => {
  //         resolve(result)
  //       })
  //     })
  //     const fileName = files[i].name.includes(':') ? files[i].name.split(':')[0] : files[i].name
  //     videos.push({ name: fileName, video: video })
  //   }
  //   setLoading(false)
  //   const productVideoLabel = 'videos'
  //   setInputs({
  //     ...Inputs,
  //     [productVideoLabel]: videos
  //   })
  //   setForceUpdate(!isForceUpdate)
  // }
  // const handleImageChange = async (e) => {
  //   const productImageLabel = 'images'
  //   const images =
  //     Inputs[productImageLabel] !== undefined && Inputs[productImageLabel].length > 0
  //       ? Inputs[productImageLabel]
  //       : []
  //   const files = e.target.files
  //   for (let i = 0; i < files.length; i++) {
  //     const image = await new Promise((resolve, reject) => {
  //       getBase64(files[i], (result) => {
  //         resolve(result)
  //       })
  //     })
  //     const fileName = files[i].name.includes(':') ? files[i].name.split(':')[0] : files[i].name
  //     images.push({ name: fileName, image: image })
  //   }
  //   setLoading(false)

  //   setInputs({
  //     ...Inputs,
  //     [productImageLabel]: images
  //   })
  //   setForceUpdate(!isForceUpdate)
  // }
  // const RemoveVideo = (e, index) => {
  //   e.preventDefault()
  //   const videos = Inputs.videos
  //   const productVideoLabel = 'videos'
  //   videos.splice(index, 1)
  //   setInputs({
  //     ...Inputs,
  //     [productVideoLabel]: videos
  //   })
  //   setForceUpdate(!isForceUpdate)
  // }
  // const RemoveImage = (e, index) => {
  //   e.preventDefault()
  //   const images = Inputs.images
  //   const productImageLabel = 'images'
  //   images.splice(index, 1)
  //   setInputs({
  //     ...Inputs,
  //     [productImageLabel]: images
  //   })
  //   setForceUpdate(!isForceUpdate)
  // }
  const validInput = (event) => {
    if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault()
    }
  }

  const handleBatchEditToggle = () => {
    setShowTextarea(!showTextarea)
  }
  const handleBatchInputChange = (e) => {
    setBatchInput(e.target.value)
  }
  const handleBatchEditApply = () => {
    const lines = batchInput.split('\n')
    const updatedProductDetails = [...Inputs.product_details]
    lines.forEach((line) => {
      const [label, value] = line.split(':').map((item) => item.trim())
      if (label && value) {
        const fieldIndex = updatedProductDetails.findIndex(
          (field) => field.label.toLowerCase() === label.toLowerCase()
        )
        if (fieldIndex !== -1) {
          updatedProductDetails[fieldIndex].value = value
        } else {
          updatedProductDetails.push({ label, value })
        }
      }
    })
    setInputs({ ...Inputs, product_details: updatedProductDetails })
    setShowTextarea(false)
    setBatchInput('')
    setForceUpdate(!isForceUpdate)
  }
  const handleBackClick = () => {
    history.push('/products', {
      state: {
        page: parseInt(fromPage) === 0 ? 1 : parseInt(fromPage),
        name: FilterName,
        sku: FilterSku,
        attribute_set_id: FilterAttributeSetId,
        priceTo: FilterPriceTo,
        priceFrom: FilterPriceFrom,
        categoryIds: FilterCategoryId,
        vendor: FilterVendor
      }
    })
  }
  const handleCountryDropdown = (e) => {
    setselectedCountryOptions(e)
    setselectedCountryIds(e.map((x) => x.id))
  }
  return (
    <>
      {loading && <Spinner />}
      <div className="content-wrapper pb-0">
        <div className="page-header">
          <h3 className="page-title mb-0">
            {' '}
            {urlParams.id !== undefined ? Title.EditProducts : Title.AddProducts}{' '}
          </h3>
          <div className="btn-group">
            {/* <button
              type="button"
              className="btn btn-dark btn-fw rounded mr-2"
              onClick={SyncMedia}
            >
              Sync Media
            </button> */}
            <button
              type="button"
              className="btn btn-dark btn-fw rounded mr-2"
              onClick={handleBackClick}
            >
              {' '}
              Back{' '}
            </button>
          </div>
        </div>
        {Object.keys(ErrorMessages).length > 0 && (
          <div className="row">
            <div className="col-12 grid-margin stretch-card">
              <div
                className="alert alert-danger w-100"
                role="alert"
              >
                <h5>Product have below errors:</h5>
                {Object.keys(ErrorMessages).map((errorKey) => {
                  return (
                    <p
                      className="mb-1"
                      key={Math.random()}
                    >
                      <b>{errorKey}</b> : {ErrorMessages[errorKey]}
                    </p>
                  )
                })}
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <form className="forms-sample">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Attribute Set</label>
                        <select
                          className="form-control custom-select"
                          name="attribute_set_id"
                          value={Inputs.attribute_set_id}
                          onChange={handleInputChanges}
                        >
                          <option value="">--Select--</option>
                          {AttributeSet.map((attributeSet, index) => (
                            <option
                              key={index}
                              value={attributeSet.id}
                            >
                              {attributeSet.name}
                            </option>
                          ))}
                        </select>
                        {validator.current.message(
                          'Attribute Set',
                          Inputs.attribute_set_id,
                          'required',
                          { className: 'error' }
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Product Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          onChange={handleInputChanges}
                          defaultValue={Inputs.name}
                          placeholder="Name"
                        />
                        {validator.current.message('Name', Inputs.name, 'required', {
                          className: 'error'
                        })}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>SKU</label>

                        <input
                          type="text"
                          className="form-control"
                          name="sku"
                          onChange={handleInputChanges}
                          onBlur={validateProductSku}
                          defaultValue={Inputs.sku}
                          placeholder="SKU"
                        />
                        {IsShowSkuError && <div className="error">{Messages.SkuAlreadyExists}</div>}
                        {validator.current.message('SKU', Inputs.sku, 'required', {
                          className: 'error'
                        })}
                      </div>
                    </div>
                    {/* <div className="col-md-3">
                      <div className="form-group">
                        <label>Vendor</label>
                        <select
                          className="form-control custom-select"
                          name="vendor"
                          value={Inputs.vendor}
                          onChange={handleInputChanges}
                        >
                          {Vendorlist.map((vendor, index) => (
                            <option
                              key={index}
                              value={vendor.value}
                            >
                              {vendor.value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div> */}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Category</label>

                        <div className="custom-dropdown text-left">
                          <button
                            type="button"
                            className={clicked || 'text-left form-control custom-select'}
                            onClick={handleClick}
                          >
                            Select Category
                          </button>
                          <div className="dropdown-menu">
                            <input
                              className="form-control m-1"
                              placeholder="Search..."
                              type="text"
                              value={filterText}
                              onChange={onFilterChange}
                            />
                            <CheckboxTree
                              checked={SelectedCategoryIds}
                              expandOnClick
                              expanded={expanded}
                              nodes={filteredCategories}
                              onCheck={onCheck}
                              onExpand={onExpand}
                              icons={{
                                parentClose: null, // Hides the folder icon for closed parent nodes
                                parentOpen: null, // Hides the folder icon for opened parent nodes
                                leaf: null
                              }}
                            />
                            {validator.current.message(
                              'Category',
                              SelectedCategoryIds,
                              'required',
                              {
                                className: 'error'
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={!Inputs.is_gift_card ? 'col-md-3' : 'd-none'}>
                      <div className="form-group">
                        <label>Weight</label>
                        <div className="d-flex align-items-center">
                          <input
                            type="number"
                            className="form-control"
                            name="weight"
                            min="0.1"
                            onChange={handleInputChanges}
                            defaultValue={Inputs.weight}
                            placeholder="Weight"
                          />
                          {/* <select
                            className="form-control custom-select w-auto ml-1 pr-4"
                            name="weight_unit"
                            value={Inputs.weight_unit}
                            onChange={handleInputChanges}
                          >
                            <option value="lb">lb</option>
                            <option value="oz">oz</option>
                            <option value="kg">kg</option>
                            <option value="g">g</option>
                          </select> */}
                        </div>
                        {/* {validator.current.message(
                          'weight',
                          Inputs.weight,
                          !Inputs.is_gift_card ? 'numeric|min:0.1,num' : '',
                          {
                            className: 'error'
                          }
                        )} */}
                        {/* {validator.current.message(
                          'Weight',
                          Inputs.weight,
                          'required|numeric|min:0.1,num',
                          {
                            className: 'error'
                          }
                        )} */}
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group row">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-sm-12"
                        >
                          Is Sold
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="is_sold"
                              onChange={handleInputChanges}
                              id="is_sold"
                              checked={Inputs.is_sold}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="is_sold"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group row">
                        <label
                          htmlFor="exampleInputUsername3"
                          className="col-sm-12"
                        >
                          Status
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="status"
                              onChange={handleInputChanges}
                              id="status"
                              checked={Inputs.status}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="status"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group row">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-sm-12"
                        >
                          Is RTS
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="is_readytoship"
                              onChange={handleInputChanges}
                              id="is_readytoship"
                              checked={Inputs.is_readytoship}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="is_readytoship"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group row">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-sm-12"
                        >
                          Is Gift Card
                        </label>
                        <div className="col-sm-12">
                          <div className="custom-control custom-switch mt-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="is_gift_card"
                              onChange={handleInputChanges}
                              id="is_gift_card"
                              checked={Inputs.is_gift_card}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="is_gift_card"
                            >
                              {' '}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="accordion"
                    className="custom-accordion"
                  >
                    <div className="card shadow-none border-top border-bottom">
                      <a
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Content</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="collapseOne"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Description</label>
                                {/* <ReactSummernote
                                  name="description"
                                  value={LongDescription}
                                  options={{
                                    height: 300, // Set editor height
                                    toolbar: [
                                      ['style', ['bold', 'italic', 'underline', 'clear']],
                                      [
                                        'font',
                                        [
                                          'fontname',
                                          'fontsize',
                                          'strikethrough',
                                          'superscript',
                                          'subscript',
                                          'style'
                                        ]
                                      ],
                                      ['para', ['ul', 'ol', 'paragraph']],
                                      ['insert', ['link', 'picture', 'video']],
                                      ['view', ['fullscreen', 'codeview', 'help']]
                                    ],
                                    fontNames: [
                                      'Arial',
                                      'Arial Black',
                                      'Comic Sans MS',
                                      'Courier New',
                                      'Georgia',
                                      'Times',
                                      'Verdana'
                                    ],
                                    fontSizeUnits: ['px', 'pt', '%']
                                  }}
                                  onChange={(e) => {
                                    handleEditorChange(e)
                                  }}
                                /> */}
                                <textarea
                                  name="description"
                                  className="form-control"
                                  onChange={handleInputChanges}
                                  defaultValue={Inputs.description}
                                  id=""
                                  rows="6"
                                  placeholder="Description"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border-bottom mt-2">
                      <a
                        data-toggle="collapse"
                        data-target="#product_size"
                        aria-expanded="true"
                        aria-controls="product_size"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Product Size</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>
                      <div
                        id="product_size"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Country</label>
                                <Multiselect
                                  onSelect={(e) => handleCountryDropdown(e)}
                                  onRemove={(e) => handleCountryDropdown(e)}
                                  options={CountryList}
                                  selectedValues={selectedCountryOptions}
                                  displayValue="name"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Size Type</label>
                                <select
                                  className="form-control custom-select"
                                  name="size_type"
                                  value={Inputs.size_type}
                                  onChange={handleInputChanges}
                                >
                                  <option value="">-- Select --</option>
                                  {SizeList.map((x) => (
                                    <option
                                      key={Math.random()}
                                      value={x.type}
                                    >
                                      {x.type}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Gender</label>
                                <select
                                  className="form-control custom-select"
                                  name="gender"
                                  value={Inputs.gender}
                                  onChange={handleInputChanges}
                                >
                                  <option value="">-- Select --</option>
                                  <option value="1">Male</option>
                                  <option value="2">Female</option>
                                  <option value="3">Unisex</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border-bottom mt-2">
                      <a
                        data-toggle="collapse"
                        data-target="#product_details"
                        aria-expanded="true"
                        aria-controls="product_details"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Product Details</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="product_details"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Product Description</label>
                                <textarea
                                  name="product_description"
                                  className="form-control"
                                  onChange={handleInputChanges}
                                  defaultValue={Inputs.product_description}
                                  id=""
                                  rows="4"
                                  placeholder="Product Description"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3 order-lg-2">
                              <div className="row">
                                <div className="col-md-9 text-right">
                                  {!showTextarea && (
                                    <button
                                      type="button"
                                      className="btn btn-custom text-white"
                                      onClick={(e) => handleAddProductDetails(e)}
                                    >
                                      + Add New
                                    </button>
                                  )}
                                  {showTextarea && (
                                    <button
                                      type="button"
                                      onClick={(e) => handleBatchEditApply(e)}
                                      className="btn btn-custom text-white"
                                    >
                                      Apply
                                    </button>
                                  )}
                                </div>
                                <div className="col-md-3 text-right">
                                  <button
                                    type="button"
                                    className="btn btn-custom text-white p-2"
                                    onClick={handleBatchEditToggle}
                                  >
                                    <i
                                      className="fa fa-pencil-square-o"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-9 order-lg-1">
                              <div className="row">
                                {showTextarea && (
                                  <div className="col-md-6">
                                    <div>
                                      <textarea
                                        className="form-control pd-textarea"
                                        value={batchInput}
                                        onChange={(e) => handleBatchInputChange(e)}
                                        rows="8"
                                        placeholder="Enter label:value pairs
                                        (e.g. height:3)"
                                      />
                                    </div>
                                    {/* <button
                                      type="button"
                                      onClick={(e) => handleBatchEditApply(e)}
                                      className="btn btn-custom text-white m-1"
                                    >
                                      Apply
                                    </button> */}
                                  </div>
                                )}
                              </div>
                              <div className="row">
                                {!showTextarea &&
                                  Inputs.product_details !== null &&
                                  Inputs.product_details.map((item, index) => (
                                    <>
                                      <div className="col-md-5">
                                        <div className="form-group">
                                          <label htmlFor={'_label_' + index}>Label</label>
                                          <input
                                            type="text"
                                            name="label"
                                            className="form-control"
                                            id={'_label_' + index}
                                            value={item.label}
                                            onChange={handleOnProductDetailsChange(index)}
                                          />
                                          {validator.current.message(
                                            'label',
                                            item.label,
                                            'required',
                                            { className: 'error' }
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-5">
                                        <div className="form-group">
                                          <label htmlFor={'_value_' + index}>Value</label>
                                          <input
                                            type="text"
                                            name="value"
                                            className="form-control"
                                            id={'_value_' + index}
                                            value={item.value}
                                            onChange={handleOnProductDetailsChange(index)}
                                          />
                                          {validator.current.message(
                                            'Value',
                                            item.value,
                                            'required',
                                            { className: 'error' }
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-auto pr-0">
                                        <button
                                          className="btn btn-danger input-btn btn-block mt-4 w-48"
                                          onClick={handleDeleteOption(index)}
                                        >
                                          X
                                        </button>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="card shadow-none border-top border-bottom">
                      <a
                        data-toggle="collapse"
                        data-target="#media"
                        aria-expanded="true"
                        aria-controls="media"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Media</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="media"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-6">
                              <label>
                                Images{' '}
                                <small className="note">
                                  (Only PNG, JPEG, JPG format allowed.)
                                </small>
                              </label>
                              <div className="custom-file-container mb-3">
                                <div className="label-container">
                                  <label>Upload</label>
                                  <a
                                    className="clear-button d-none"
                                    href="javascript:void(0)"
                                    title="Clear Image"
                                  >
                                    ×
                                  </a>
                                </div>
                                <label className="input-container">
                                  <input
                                    accept=".png,.jpg,.jpeg"
                                    aria-label="Choose File"
                                    className="input-hidden"
                                    onChange={handleImageChange}
                                    multiple
                                    type="file"
                                  />
                                  <span className="input-visible">
                                    {Inputs.images.length > 0
                                      ? Inputs.images.length + ' files selected'
                                      : 'Choose Image...'}
                                    <span className="browse-button">Browse</span>
                                  </span>
                                </label>
                              </div>
                              <div className="row">
                                {Inputs.images.map((image, index) => {
                                  return (
                                    <div
                                      className="col-md-4 mb-4"
                                      key={Math.random()}
                                    >
                                      <button
                                        className="float-right btn-video-close"
                                        title="Remove"
                                        type="button"
                                        onClick={(e) => RemoveImage(e, index)}
                                      >
                                        ×
                                      </button>
                                      <img
                                        src={image.image}
                                        width={150}
                                      />
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label>
                                Video <small className="note">(Only MP4 format allowed.)</small>
                              </label>
                              <div className="custom-file-container mb-3">
                                <div className="label-container">
                                  <label>Upload</label>
                                  <a
                                    className="clear-button"
                                    href="javascript:void(0)"
                                    title="Clear Image"
                                  >
                                    ×
                                  </a>
                                </div>
                                <label className="input-container">
                                  <input
                                    accept=".mp4"
                                    aria-label="Choose File"
                                    className="input-hidden"
                                    onChange={handleVideoChange}
                                    multiple
                                    type="file"
                                  />
                                  <span className="input-visible">
                                    {Inputs.videos.length > 0
                                      ? Inputs.videos.length + ' files selected'
                                      : 'Choose Video...'}
                                    <span className="browse-button">Browse</span>
                                  </span>
                                </label>
                              </div>
                              <div className="row">
                                {Inputs.videos.map((video, index) => {
                                  return (
                                    <div
                                      className="col-md-4"
                                      key={Math.random()}
                                    >
                                      <button
                                        className="float-right btn-video-close"
                                        title="Remove"
                                        type="button"
                                        onClick={(e) => RemoveVideo(e, index)}
                                      >
                                        ×
                                      </button>
                                      <video
                                        className="VideoInput_video"
                                        controls
                                        width="100%"
                                        muted
                                        playsInline=""
                                        loop
                                        src={video.video}
                                        height={150}
                                      />
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {AttributesBySet.length > 0 && Inputs.sku !== '' && (
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Configurations</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>

                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row mb-3">
                              <div
                                className="col-md-9"
                                style={{ fontSize: '14px' }}
                              >
                                Configurable products allow customers to choose options (Ex: 14K
                                White Gold). You need to create a simple product for each
                                configuration (Ex: a product for each quality).
                              </div>
                            </div>
                            <div className="row my-2">
                              {AttributesBySet.map((item) => {
                                return (
                                  <div
                                    className="col-md-6"
                                    key={Math.random()}
                                  >
                                    <div className="form-group">
                                      <div className="mb-1 d-flex align-items-center">
                                        <label className="mb-0">{item.attribute_name}</label>
                                        <small className="note ml-1 mt-0 pt-0">
                                          {' (' + item.attribute_code + ')'}
                                        </small>
                                        <a
                                          className="pointer ml-auto float-right fs-14 custom-color"
                                          onClick={(e) => onSelectAll(item.attribute_code)}
                                        >
                                          Select All
                                        </a>
                                      </div>
                                      <Multiselect
                                        onSelect={(e) =>
                                          handleOptionChange(
                                            e,
                                            item.attribute_code,
                                            item.attribute_id,
                                            item.attribute_name
                                          )
                                        }
                                        onRemove={(e) =>
                                          handleOptionChange(
                                            e,
                                            item.attribute_code,
                                            item.attribute_id,
                                            item.attribute_name
                                          )
                                        }
                                        options={item.options}
                                        selectedValues={SelectedAttributeTags[item.attribute_code]}
                                        displayValue="name"
                                      />
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                            <div className="row mt-2 mb-4 align-items-center">
                              <div className="col-auto form-group mb-0">
                                <label htmlFor="group_by">Group By</label>
                              </div>
                              <div className="col-md-3">
                                <select
                                  className="form-control custom-select"
                                  name="group_by"
                                  onChange={handleChangeGroupBy}
                                  value={GroupByProperty}
                                >
                                  {SelectedAttributes.map((attribute) => {
                                    return (
                                      <option
                                        value={attribute.attribute_code}
                                        key={Math.random()}
                                      >
                                        {attribute.attribute_name}
                                      </option>
                                    )
                                  })}
                                </select>
                              </div>
                            </div>

                            <div className="table-responsive">
                              <table className="table table-configuration">
                                <thead>
                                  <tr>
                                    <th
                                      className="text-center"
                                      style={{ width: '30%' }}
                                    >
                                      Variant
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{ width: '20%' }}
                                    >
                                      Price
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{ width: '20%' }}
                                    >
                                      System SKU
                                    </th>
                                    <td></td>
                                  </tr>
                                </thead>
                              </table>
                              <Accordion
                                activeKey={activeKey}
                                onSelect={handleSelect}
                                className="custom-product-accordion"
                              >
                                {Object.keys(AttributeOptions).map((optionKey, optionIndex) => {
                                  return (
                                    <>
                                      {ProductAttributeOptions !== undefined &&
                                        ProductAttributeOptions[optionKey] !== undefined &&
                                        ProductAttributeOptions[optionKey].length > 0 && (
                                          <Accordion.Item
                                            eventKey={optionKey}
                                            key={optionKey}
                                          >
                                            <Accordion.Header>
                                              <div
                                                className="accordion-header-div"
                                                onClick={() => handleAccordionClick('0')}
                                              >
                                                <table
                                                  className="table"
                                                  data-index={optionIndex}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td style={{ width: '30%' }}>
                                                        <div className="d-flex justify-content-center variant-image-label">
                                                          <img
                                                            className="variant_img pointer"
                                                            onClick={(e) =>
                                                              openMediaPopup(e, optionKey, '')
                                                            }
                                                            src={
                                                              ProductAttributeOptions[optionKey][0]
                                                                ?.base_image !== null &&
                                                              ProductAttributeOptions[optionKey][0]
                                                                ?.base_image !== '' &&
                                                              ProductAttributeOptions[optionKey][0]
                                                                ?.base_image !== undefined
                                                                ? ProductAttributeOptions[
                                                                    optionKey
                                                                  ][0]?.base_image
                                                                : Common.setImage(
                                                                    'assets/images/default.png'
                                                                  )
                                                            }
                                                          />
                                                          <div className="ml-2 text-left variant-count-label">
                                                            {ProductAttributeOptions[optionKey][
                                                              optionIndex
                                                            ] !== undefined
                                                              ? ProductAttributeOptions[optionKey][
                                                                  optionIndex
                                                                ]?.attributes.filter(
                                                                  (o) =>
                                                                    o.attribute_code ===
                                                                    GroupByProperty
                                                                ).length > 0 && (
                                                                  <>
                                                                    <h6>
                                                                      {
                                                                        ProductAttributeOptions[
                                                                          optionKey
                                                                        ][
                                                                          optionIndex
                                                                        ]?.attributes.filter(
                                                                          (o) =>
                                                                            o.attribute_code ===
                                                                            GroupByProperty
                                                                        )[0].option_value
                                                                      }
                                                                    </h6>
                                                                  </>
                                                                )
                                                              : ProductAttributeOptions[
                                                                  optionKey
                                                                ][0]?.attributes.filter(
                                                                  (o) =>
                                                                    o.attribute_code ===
                                                                    GroupByProperty
                                                                ).length > 0 && (
                                                                  <>
                                                                    <h6>
                                                                      {
                                                                        ProductAttributeOptions[
                                                                          optionKey
                                                                        ][0]?.attributes.filter(
                                                                          (o) =>
                                                                            o.attribute_code ===
                                                                            GroupByProperty
                                                                        )[0].option_value
                                                                      }
                                                                    </h6>
                                                                  </>
                                                                )}
                                                            {AttributeOptions[optionKey].length +
                                                              ' variants'}{' '}
                                                            <i className="fa fa-chevron-down fs-12"></i>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td style={{ width: '20%' }}>
                                                        <div className="input-group">
                                                          <div className="input-group-prepend">
                                                            <span className="input-group-text form-control text-dark bg-white pr-1 pt-3">
                                                              $
                                                            </span>
                                                          </div>
                                                          <input
                                                            type="number"
                                                            name="price"
                                                            className="border-left-0 pl-0 border form-control"
                                                            defaultValue={
                                                              ProductAttributeOptions[optionKey][0]
                                                                ?.price
                                                                ? ProductAttributeOptions[
                                                                    optionKey
                                                                  ][0]?.price
                                                                : 0
                                                            }
                                                            min={0}
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={handleMainVariationChange(
                                                              optionKey
                                                            )}
                                                            onWheel={(e) => e.target.blur()}
                                                            onKeyDown={(e) => validInput(e)}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td style={{ width: '20%' }}>
                                                        {/* <input
                                                    type="text"
                                                    name="sku"
                                                    className="form-control"
                                                    defaultValue={
                                                      ProductAttributeOptions[optionKey][0]
                                                        ?.sku
                                                    }
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={handleMainVariationChange(optionKey)}
                                                  /> */}
                                                      </td>
                                                      {/* <td style={{ width: '20%' }}></td> */}
                                                      <td></td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                              <table className="table">
                                                <tbody>
                                                  {AttributeOptions[optionKey].map(
                                                    (item, index) => (
                                                      <tr
                                                        key={Math.random()}
                                                        data-toggle="collapse"
                                                        className="accordion-toggle"
                                                        data-target={
                                                          '#attribute_option_' + optionKey
                                                        }
                                                      >
                                                        <td
                                                          className="text-center"
                                                          style={{ width: '30%' }}
                                                        >
                                                          <>
                                                            <div className="d-flex justify-content-center variant-image-label">
                                                              <img
                                                                className="variant_img pointer"
                                                                onClick={(e) =>
                                                                  openMediaPopup(
                                                                    e,
                                                                    optionKey,
                                                                    index
                                                                  )
                                                                }
                                                                src={
                                                                  ProductAttributeOptions[
                                                                    optionKey
                                                                  ][index]?.base_image !== null &&
                                                                  ProductAttributeOptions[
                                                                    optionKey
                                                                  ][index]?.base_image !== '' &&
                                                                  ProductAttributeOptions[
                                                                    optionKey
                                                                  ][index]?.base_image !== undefined
                                                                    ? ProductAttributeOptions[
                                                                        optionKey
                                                                      ][index]?.base_image
                                                                    : Common.setImage(
                                                                        'assets/images/default.png'
                                                                      )
                                                                }
                                                              />
                                                              <div className="ml-2 text-left variant-count-label">
                                                                <h6 className="demo pl-3 fs-14">
                                                                  {ProductAttributeOptions[
                                                                    optionKey
                                                                  ][index]?.attributes.length > 1
                                                                    ? [
                                                                        ...new Set(
                                                                          ProductAttributeOptions[
                                                                            optionKey
                                                                          ][index]?.attributes
                                                                            .filter(
                                                                              (o) =>
                                                                                o.attribute_code !==
                                                                                GroupByProperty
                                                                            )
                                                                            .map(
                                                                              (item) =>
                                                                                item.option_value
                                                                            )
                                                                        )
                                                                      ].join('/')
                                                                    : [
                                                                        ...new Set(
                                                                          ProductAttributeOptions[
                                                                            optionKey
                                                                          ][index]?.attributes.map(
                                                                            (item) =>
                                                                              item.option_value
                                                                          )
                                                                        )
                                                                      ].join('/')}
                                                                </h6>
                                                              </div>
                                                            </div>
                                                            <input
                                                              type="file"
                                                              accept="image/*"
                                                              id={
                                                                'variant_image_' +
                                                                optionKey +
                                                                '_' +
                                                                index
                                                              }
                                                              name="image"
                                                              onChange={handleVariationChange(
                                                                optionKey,
                                                                index
                                                              )}
                                                            />
                                                          </>
                                                        </td>
                                                        <td style={{ width: '20%' }}>
                                                          <div className="input-group">
                                                            <div className="input-group-prepend">
                                                              <span className="input-group-text form-control text-dark bg-white pr-1 pt-3">
                                                                $
                                                              </span>
                                                            </div>
                                                            <input
                                                              type="number"
                                                              name="price"
                                                              className="border-left-0 pl-0 border form-control"
                                                              defaultValue={
                                                                ProductAttributeOptions[optionKey][
                                                                  index
                                                                ]?.price
                                                                  ? ProductAttributeOptions[
                                                                      optionKey
                                                                    ][index]?.price
                                                                  : 0
                                                              }
                                                              min={0}
                                                              onChange={handleVariationChange(
                                                                optionKey,
                                                                index
                                                              )}
                                                              onWheel={(e) => e.target.blur()}
                                                              onKeyDown={(e) => validInput(e)}
                                                            />
                                                          </div>
                                                          {validator.current.message(
                                                            'Price',
                                                            ProductAttributeOptions[optionKey][
                                                              index
                                                            ]?.price,
                                                            'required',
                                                            { className: 'error' }
                                                          )}
                                                        </td>
                                                        <td style={{ width: '20%' }}>
                                                          <input
                                                            type="text"
                                                            name="sku"
                                                            disabled
                                                            className="form-control"
                                                            defaultValue={
                                                              ProductAttributeOptions[optionKey][
                                                                index
                                                              ]?.sku
                                                            }
                                                            onChange={handleVariationChange(
                                                              optionKey,
                                                              index
                                                            )}
                                                          />
                                                          {validator.current.message(
                                                            'Child SKU',
                                                            ProductAttributeOptions[optionKey][
                                                              index
                                                            ]?.sku,
                                                            `required|not_in:${Inputs.sku}`,
                                                            {
                                                              className: 'error',
                                                              messages: {
                                                                not_in:
                                                                  'Child product SKU should not be the same as main SKU.'
                                                              }
                                                            }
                                                          )}
                                                          {/* {validator.current.message(
                                                            'SKU',
                                                            ProductAttributeOptions[
                                                              optionKey
                                                            ][index]?.sku,
                                                            'required',
                                                            { className: 'error' }
                                                          )} */}
                                                        </td>
                                                        <td>
                                                          {ProductAttributeOptions[optionKey][index]
                                                            ?.isdisable === 1 ? (
                                                            <button
                                                              type="button"
                                                              className="btn btn-success"
                                                              onClick={(e) =>
                                                                handleDeleteConfigureoption(
                                                                  e,
                                                                  optionKey,
                                                                  ProductAttributeOptions[
                                                                    optionKey
                                                                  ][index]?.id,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              undo
                                                            </button>
                                                          ) : (
                                                            <button
                                                              type="button"
                                                              className="btn btn-danger"
                                                              onClick={(e) =>
                                                                handleDeleteConfigureoption(
                                                                  e,
                                                                  optionKey,
                                                                  ProductAttributeOptions[
                                                                    optionKey
                                                                  ][index]?.id,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              <i
                                                                className="fa fa-trash-o"
                                                                aria-hidden="true"
                                                              ></i>
                                                            </button>
                                                          )}
                                                        </td>

                                                        {/* <td>
                                                {item.attributes !== undefined &&
                                                  item.attributes.map((item) => (
                                                    <>
                                                      {item.option_name}: {item.option_value} ,
                                                    </>
                                                  ))}
                                              </td> */}
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        )}
                                    </>
                                  )
                                })}
                              </Accordion>
                            </div>
                            {/* {validator.current.message(
                            'Configuration',
                            ConfigurableProducts,
                            'required',
                            { className: 'error' }
                          )} */}
                          </div>
                        </div>
                      </div>
                    )}
                    {AttributesBySet.length > 0 && Inputs.sku !== '' && (
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#standalone_attributes"
                          aria-expanded="true"
                          aria-controls="standalone_attributes"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Standalone Attribute</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>

                        <div
                          id="standalone_attributes"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row my-2">
                              {AttributesBySet.filter(
                                (attr) =>
                                  !SelectedAttributes.some(
                                    (selected) => selected.attribute_code === attr.attribute_code
                                  )
                              ).map((item) => {
                                return (
                                  <div
                                    className="col-md-6"
                                    key={Math.random()}
                                  >
                                    <div className="form-group">
                                      <div className="mb-1 d-flex align-items-center">
                                        <label className="mb-0">{item.attribute_name}</label>
                                        <small className="note ml-1 mt-0 pt-0">
                                          {' (' + item.attribute_code + ')'}
                                        </small>
                                        <a
                                          className="pointer ml-auto float-right fs-14 custom-color"
                                          onClick={(e) =>
                                            onSelectAllStandaloneOptions(item.attribute_code)
                                          }
                                        >
                                          Select All
                                        </a>
                                      </div>
                                      <Multiselect
                                        onSelect={(e) =>
                                          handleStandAloneOptionChange(
                                            e,
                                            item.attribute_code,
                                            item.attribute_id,
                                            item.attribute_name
                                          )
                                        }
                                        onRemove={(e) =>
                                          handleStandAloneOptionChange(
                                            e,
                                            item.attribute_code,
                                            item.attribute_id,
                                            item.attribute_name
                                          )
                                        }
                                        options={item.options}
                                        selectedValues={
                                          SelectedStandAloneAttributeTags[item.attribute_code]
                                        }
                                        displayValue="name"
                                      />
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {CustomAttributes.length > 0 && (
                      <div className="card shadow-none border-bottom mt-2">
                        <a
                          data-toggle="collapse"
                          data-target="#collapseThird"
                          aria-expanded="true"
                          aria-controls="collapseThird"
                          className="collapsed"
                        >
                          <div className="card-header border-none px-3">
                            <label className="mb-0">Attributes</label>
                            <i className="fa fa-chevron-down fs-12 float-right"></i>
                          </div>
                        </a>
                        <div
                          id="collapseThird"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div className="card-body p-3 pt-0 font-dark">
                            <div className="row">
                              <div className="col-md-12">
                                {CustomAttributes.map((attribute, index) => (
                                  <div
                                    key={Math.random()}
                                    className="row mt-2"
                                  >
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label htmlFor={'attribute_' + attribute.attribute_id}>
                                          {attribute.attribute_name}
                                        </label>
                                        <input
                                          type="text"
                                          name={attribute.attribute_code}
                                          onChange={(e) => handleCustomAttributeValue(e, index)}
                                          defaultValue={attribute.attribute_value}
                                          id={'attribute_' + attribute.attribute_id}
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="card shadow-none border-bottom mt-2">
                      <a
                        data-toggle="collapse"
                        data-target="#collapseFifth"
                        aria-expanded="true"
                        aria-controls="collapseFifth"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Search Engine Optimization</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="collapseFifth"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Meta Title</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_title"
                                  onChange={handleInputChanges}
                                  defaultValue={Inputs.meta_title}
                                  placeholder="Meta Title"
                                />
                                {/* {validator.current.message('Meta Title', Inputs.meta_title, 'required', { className: 'error' })} */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Meta Keywords</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_keywords"
                                  onChange={handleInputChanges}
                                  defaultValue={Inputs.meta_keywords}
                                  placeholder="Meta Keywords"
                                />
                                {/* {validator.current.message('Meta Keywords', Inputs.meta_keywords, 'required', { className: 'error' })} */}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Meta Description</label>
                                <textarea
                                  name="meta_description"
                                  className="form-control"
                                  onChange={handleInputChanges}
                                  defaultValue={Inputs.meta_description}
                                  id=""
                                  rows="3"
                                  placeholder="Meta Description"
                                ></textarea>
                                {/* {validator.current.message('Meta Description', Inputs.meta_description, 'required', { className: 'error' })} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border-bottom overflow-initial mt-2">
                      <a
                        data-toggle="collapse"
                        data-target="#collapseSix"
                        aria-expanded="true"
                        aria-controls="collapseSix"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Related Products</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="collapseSix"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  Related products are shown to customers in addition to the item
                                  the customer is looking at.
                                </label>
                                <ReactTags
                                  selected={ProductTags}
                                  suggestions={Products}
                                  onDelete={onDeleteProduct}
                                  onAdd={onSelectProduct}
                                  onInput={onChangeProduct}
                                  placeholderText="Enter SKU or Product Name"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border-bottom mt-2">
                      <a
                        data-toggle="collapse"
                        data-target="#can_be_set_with"
                        aria-expanded="true"
                        aria-controls="can_be_set_with"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Can Be Set With</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="can_be_set_with"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-2 order-lg-2">
                              <div className="row">
                                <div className="col-md-12 text-right">
                                  <button
                                    type="button"
                                    className="btn btn-custom text-white"
                                    onClick={(e) => handleAddCanBeSet(e)}
                                  >
                                    + Add New
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-10 order-lg-1">
                              <div className="row">
                                {Inputs.can_be_set_with.map((item, index) => (
                                  <>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label htmlFor={'shape_' + index}>Shape</label>
                                        <select
                                          className="form-control custom-select"
                                          name="shape"
                                          id={'shape_' + index}
                                          onChange={handleOnCanBeSetChange(index)}
                                          value={item.shape}
                                        >
                                          <option value="">Select</option>
                                          {Shapes.map((shape) => {
                                            return (
                                              <option
                                                value={shape.value}
                                                key={Math.random()}
                                                disabled={
                                                  Inputs.can_be_set_with.filter(
                                                    (x) => x.shape === shape.value
                                                  ).length > 0
                                                }
                                              >
                                                {shape.value}
                                              </option>
                                            )
                                          })}
                                        </select>
                                        {/* {validator.current.message(
                                          'Shape',
                                          item.shape,
                                          'required',
                                          {
                                            className: 'error'
                                          }
                                        )} */}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label htmlFor={'carat_from_' + index}>Carat From</label>
                                        <input
                                          type="number"
                                          name="carat_from"
                                          className="form-control"
                                          id={'carat_from_' + index}
                                          value={item.carat_from}
                                          onChange={handleOnCanBeSetChange(index)}
                                          min={0.1}
                                          step="0.1"
                                        />
                                        {validator.current.message(
                                          'Carat From',
                                          item.carat_from,
                                          'numeric|min:0.1,num',
                                          { className: 'error' }
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label htmlFor={'carat_to_' + index}>Carat To</label>
                                        <input
                                          type="number"
                                          name="carat_to"
                                          className="form-control"
                                          id={'carat_to_' + index}
                                          value={item.carat_to}
                                          onChange={handleOnCanBeSetChange(index)}
                                          min={0.1}
                                          step="0.1"
                                        />
                                        {validator.current.message(
                                          'Carat To',
                                          item.carat_to,
                                          'numeric|min:0.1,num',
                                          { className: 'error' }
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-auto pr-0">
                                      <button
                                        className="btn btn-danger input-btn btn-block mt-4 w-48"
                                        onClick={handleDelete(index)}
                                      >
                                        X
                                      </button>
                                    </div>
                                  </>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card shadow-none border-bottom mt-2 d-none">
                      <a
                        data-toggle="collapse"
                        data-target="#side_diamonds"
                        aria-expanded="true"
                        aria-controls="side_diamonds"
                        className="collapsed"
                      >
                        <div className="card-header border-none px-3">
                          <label className="mb-0">Side Diamond Details</label>
                          <i className="fa fa-chevron-down fs-12 float-right"></i>
                        </div>
                      </a>

                      <div
                        id="side_diamonds"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="card-body p-3 pt-0 font-dark">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor="side_diamonds_size">Diamond Size</label>
                                <input
                                  type="text"
                                  name="side_diamonds_size"
                                  className="form-control"
                                  id="side_diamonds_size"
                                  value={Inputs.side_diamonds_size}
                                  onChange={handleInputChanges}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor="side_diamonds_pieces">Diamond Pieces</label>
                                <input
                                  type="number"
                                  name="side_diamonds_pieces"
                                  className="form-control"
                                  id="side_diamonds_pieces"
                                  value={Inputs.side_diamonds_pieces}
                                  onChange={handleInputChanges}
                                  min={0}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor="side_diamonds_weight">Diamond Weight</label>
                                <div className="d-flex align-items-center">
                                  <input
                                    type="number"
                                    name="side_diamonds_weight"
                                    className="form-control"
                                    id="side_diamonds_weight"
                                    value={Inputs.side_diamonds_weight}
                                    onChange={handleInputChanges}
                                    min={0}
                                    step="0.1"
                                  />
                                  {/* <select
                                    className="form-control custom-select w-auto ml-1 pr-4"
                                    name="side_diamonds_weight_unit"
                                    value={Inputs.side_diamonds_weight_unit}
                                    onChange={handleInputChanges}
                                  >
                                    <option value="lb">lb</option>
                                    <option value="oz">oz</option>
                                    <option value="kg">kg</option>
                                    <option value="g">g</option>
                                  </select> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <button
                        type="button"
                        onClick={SubmitForm}
                        className="btn btn-custom text-white mr-2"
                        ref={submitButtonRef}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleBackClick}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {IsShowImagesVideoModal && (
          <UploadMedia
            props={{
              IsShowImagesVideoModal: IsShowImagesVideoModal,
              ProductMedia: ProductMedia,
              index: ProductIndex,
              SelectedMediaFiles: SelectedMedia,
              CurrentImageVariant: CurrentImageVariant
            }}
            closeMediaPopup={closeMediaPopup}
            onSubmitMedia={onSubmitMedia}
          />
        )}
      </div>
    </>
  )
}

export default AddProducts
